import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction, SuccessMessageAction} from "../components/CustomToast/actions";

export const LOADED_USERS = '[users] Loaded users';
export const LOADED_USERS_PAGES = '[users] Loaded pages';
export const LOADED_USERS_TOTAL = '[users] Loaded total';
export const LOADED_USERS_CURRENT = '[users] Loaded current';
export const LOADED_USERS_LIMIT = '[users] Loaded limit';
export const SET_USER = '[user] Set user';
export const LOADED_ME = '[user] Loaded Me';
export const AUTH_CODE_ISSUED = '[Login] Auth Code Issued';
export const LOADED_ME_DISTRICT_SUBSCRIPTION = '[me] District subscription loaded';
export const LOADED_ME_SCHOOL_SUBSCRIPTION = '[me] School subscription loaded';
export const LOADED_ME_PREFERENCES = '[me] Preferences loaded';

export const LoadUsersAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Users')))
        .then(() => MindsetsJsSDK().API.get('users', options))
        .then(response => {
            dispatch(LoadedUsersAction(response.items));
            dispatch(LoadedUsersCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedUsersLimitAction(response.limit));
            dispatch(LoadedUsersPagesAction(response.pages));
            dispatch(LoadedUsersTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedUsersAction = payload => ({
    type: LOADED_USERS,
    payload
});
export const LoadedUsersPagesAction = payload => ({
    type: LOADED_USERS_PAGES,
    payload
});
export const LoadedUsersTotalAction = payload => ({
    type: LOADED_USERS_TOTAL,
    payload
});
export const LoadedUsersCurrentAction = payload => ({
    type: LOADED_USERS_CURRENT,
    payload
});
export const LoadedUsersLimitAction = payload => ({
    type: LOADED_USERS_LIMIT,
    payload
});

export const LoadUserAction = (user_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.get('users/' + user_id, options))
        .then(response => dispatch(SetUserAction(response.user)))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SetUserAction = payload => ({
    type: SET_USER,
    payload
});
export const UpdateUserAction = (user_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.put(`users/${user_id}`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const CreateUsersAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.post('users', data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Users have been created')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const ResetUserPasswordAction = (user_id, new_password) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Users')))
        .then(() => MindsetsJsSDK().API.patch(`users/${user_id}/password/reset`, {new_password}))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const LoadMeAction = options => dispatch => {
    return Promise.resolve()
        .then(() => MindsetsJsSDK().API.get('me', options))
        .then(response => {
            dispatch(LoadedMeAction(response.user));

            return response.user;
        });
};
export const LoadedMeAction = payload => {
    return {
        type: LOADED_ME,
        payload
    }
};
export const LoggedInAction = () => () => {
    window.location.href = '/';

    return null;
};
export const AuthCodeIssuedAction = payload => {
    return {
        type: AUTH_CODE_ISSUED,
        payload
    }
};

export const RequestPasswordChangeAction = (data, options) => dispatch => {
    dispatch(LoadingAction(true));
    return MindsetsJsSDK().API.post('auth/password/forgot', data, options)
        .then(() => dispatch(SuccessMessageAction(`The reset password link has been sent to you. Check your email for instructions.`, true)))
        .catch(error => {
            console.error(error);
            dispatch(ErrorMessageAction(`Error. Reload your page and try again.`, true));
        })
        .then(() => dispatch(LoadingAction(false)));
}
export const LoadMeSubscriptionsAction = options => dispatch => {
    dispatch(LoadingAction(true));
    return MindsetsJsSDK().API.get('subscriptions', options)
        .then(response => {
            dispatch(LoadedMeDistrictSubscriptionAction(response.district_subscription));
            dispatch(LoadedMeSchoolSubscriptionAction(response.school_subscription));
        })
        .catch(error => {
            console.error(error);
            dispatch(ErrorMessageAction(`Error. Reload your page and try again.`, true));
        })
        .then(() => dispatch(LoadingAction(false)));
}
export const LoadedMeDistrictSubscriptionAction = payload => ({
    type: LOADED_ME_DISTRICT_SUBSCRIPTION,
    payload
});
export const LoadedMeSchoolSubscriptionAction = payload => ({
    type: LOADED_ME_SCHOOL_SUBSCRIPTION,
    payload
});
export const LoadMePreferencesAction = options => dispatch => {
    dispatch(LoadingAction(true));
    return MindsetsJsSDK().API.get('preferences', options)
        .then(response => {
            dispatch(LoadedMePreferencesAction(response.preferences));
            dispatch(LoadingAction(false));

            return response.preferences;
        })
        .catch(error => {
            console.error(error);
            dispatch(ErrorMessageAction(`Error. Reload your page and try again.`, true));
        });
}
export const LoadedMePreferencesAction = payload => ({
    type: LOADED_ME_PREFERENCES,
    payload
});
export const UpdateMePreferencesAction = (data, options) => dispatch => {
    dispatch(LoadingAction(true, 'Updating preferences'));
    return MindsetsJsSDK().API.put('preferences', data, options)
        .then(() => dispatch(SuccessMessageAction('Communication preferences have been successfully updated')))
        .catch(error => {
            console.error(error);
            dispatch(ErrorMessageAction(`Error. Reload your page and try again.`, true));
        })
        .then(() => dispatch(LoadingAction(false)));
}
export const UpdateMeAction = (data, options) => dispatch => {
    dispatch(LoadingAction(true, 'Updating your profile'));

    return MindsetsJsSDK().API.put('me', data, options)
        .then(response => {
            dispatch(LoadingAction(false));
            dispatch(SuccessMessageAction('Saved'));

            return response.user;
        });
}
